// AIMS PWA - offline database (Dexie / IndexedDB).
//
// Single source of local persistence for the Offline Inspection feature
// (AIMS-Offline-Inspection.md §3) plus the scan-history log. Everything the app
// needs to inspect with no signal lives here.
//
// ── Schema versioning rules (§7/§10) ──────────────────────────────────────────
// • Bump the version and add a NEW .version(n).stores({...}) block for schema
//   changes; Dexie migrates forward automatically.
// • NEVER drop or repurpose the `outbox` / `imageQueue` stores in a migration -
//   they hold un-synced field work. Losing them loses inspections.
// • Dexie only needs indexed props in the schema string; full objects are stored
//   regardless. Primary key is the first token.

import Dexie from 'dexie';

export const db = new Dexie('AIMSOffline');

// v1 - scan history only (shipped first; the scanner writes here).
db.version(1).stores({
  // ++id = auto PK; ts indexed for "most recent first" ordering.
  scanHistory: '++id, ts',
});

// v2 - full offline-inspection stores. Additive: v1 data (scanHistory) is
// preserved untouched by this upgrade.
db.version(2).stores({
  scanHistory: '++id, ts',
  // Per-visit asset pool. Compound PK [visitId+catNo] lets the same asset exist
  // under different visits; secondary indexes for lookups by visit / id.
  assets: '[visitId+catNo], visitId, catNo, assetId',
  // Checklist templates, keyed by audit type (shared across visits - one copy).
  checklistTemplates: 'auditType',
  // item → auditType mapping rows (an item can map to several audit types).
  typeMap: '++id, item, auditType',
  // Completed inspections awaiting push. PK = device-minted clientInspectionId
  // (idempotency key); indexed by visit + sync state.
  outbox: 'clientInspectionId, visitId, syncedAt',
  // Photo blobs awaiting upload. PK = device-minted clientImageId.
  imageQueue: 'clientImageId, clientInspectionId, visitId',
  // Per-visit sync/lease metadata (last sync, lease info, pending counts).
  syncMeta: 'visitId',
});

export default db;
